'use strict';

/**
 * @ngdoc service
 * @name prepApp.BasicService
 * @description
 * # Service
 * Service in the prepApp.
 */
angular.module('prepApp')
    .service('BasicService', function ($http, $cookies, $document, $location) {
        return {
            http: $http,
            cookies: $cookies,
            document: $document,
            location: $location
        };
    });
